import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';

const Navbar = () => {
  const { getCartCount } = useCart();
  const location = useLocation();
  const cartCount = getCartCount();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-zinc-950 border-b border-zinc-800 sticky top-0 z-50">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_eco-fuel-store/artifacts/q8ugwsf5_Goodpure%20%282%29.png" 
              alt="GreenPure Biofuel Logo" 
              className="w-12 h-12 object-contain"
            />
            <span className="font-heading text-xl font-bold tracking-tight uppercase text-white">
              GreenPure Biofuel
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm uppercase tracking-wider font-medium transition-colors ${
                isActive('/') ? 'text-lime-400' : 'text-zinc-400 hover:text-white'
              }`}
              data-testid="nav-home"
            >
              Home
            </Link>
            <Link
              to="/products"
              className={`text-sm uppercase tracking-wider font-medium transition-colors ${
                isActive('/products') ? 'text-lime-400' : 'text-zinc-400 hover:text-white'
              }`}
              data-testid="nav-products"
            >
              Products
            </Link>
            <Link
              to="/education"
              className={`text-sm uppercase tracking-wider font-medium transition-colors ${
                isActive('/education') ? 'text-lime-400' : 'text-zinc-400 hover:text-white'
              }`}
              data-testid="nav-education"
            >
              Learn More
            </Link>
            <Link
              to="/briquette-info"
              className={`text-sm uppercase tracking-wider font-medium transition-colors ${
                isActive('/briquette-info') ? 'text-lime-400' : 'text-zinc-400 hover:text-white'
              }`}
              data-testid="nav-briquette-info"
            >
              Briquette Info
            </Link>
            <Link
              to="/bio-cng-plant"
              className={`text-sm uppercase tracking-wider font-medium transition-colors ${
                isActive('/bio-cng-plant') ? 'text-lime-400' : 'text-zinc-400 hover:text-white'
              }`}
              data-testid="nav-bio-cng-plant"
            >
              Bio-CNG Plant
            </Link>
            <Link
              to="/testimonials"
              className={`text-sm uppercase tracking-wider font-medium transition-colors ${
                isActive('/testimonials') ? 'text-lime-400' : 'text-zinc-400 hover:text-white'
              }`}
              data-testid="nav-testimonials"
            >
              Testimonials
            </Link>
            <Link
              to="/vendor-empanelment"
              className={`text-sm uppercase tracking-wider font-medium transition-colors ${
                isActive('/vendor-empanelment') ? 'text-lime-400' : 'text-zinc-400 hover:text-white'
              }`}
              data-testid="nav-vendor"
            >
              Vendor Empanelment
            </Link>
          </div>

          <Link
            to="/cart"
            className="relative p-2 hover:bg-zinc-900 transition-colors"
            data-testid="nav-cart"
          >
            <ShoppingCart className="w-6 h-6 text-lime-400" />
            {cartCount > 0 && (
              <span className="absolute -top-1 -right-1 w-5 h-5 bg-orange-500 text-white text-xs font-bold flex items-center justify-center" data-testid="cart-count">
                {cartCount}
              </span>
            )}
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
